<template>
  <div class="sku-info">
    <template v-if="!isOpen">
      <price-tag
        v-if="priceTag"
        :tag="priceTag"
        :sub="priceSub"
        class="sku-prce-tag"
      ></price-tag>
    </template>

    <div class="sku-price">
      <template v-if="!isOpen">
        <div v-if="!!sku.skuPrice.priceShield" class="price-shield">
          {{ sku.skuPrice.priceShieldText }}
        </div>
        <good-price v-else :sku="sku"></good-price>
      </template>

      <OpenSsuBtn
        :is-open="isOpen"
        :bg-start-color="'#F03100'"
        :bg-end-color="'#F03100'"
        class="open-ssu-btn"
        :border-radius="0.12"
        :width="1.36"
        :height="0.64"
        @openChange="openChange"
      />
    </div>
  </div>
</template>

<script>
import priceTag from '../priceTag'
import GoodPrice from '../goodPrice'
import OpenSsuBtn from '@/common/widgets/open_ssu_btn/index.vue'
export default {
  components: {
    priceTag,
    OpenSsuBtn,
    GoodPrice
  },
  props: {
    sku: {
      type: Object,
      default: () => {}
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    priceTag() {
      const priceTag = this.sku.skuPrice?.priceUpperTag?.[0]?.tag || ''
      return priceTag
    },
    priceSub() {
      const suffixText = this.sku.skuPrice?.priceUpperTag?.[0]?.suffixText || ''
      return suffixText
    }
  },
  created() {},
  methods: {
    openChange() {
      this.$emit('openChange', !this.isOpen)
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-price {
  display: flex;
  align-items: center;
  position: relative;
  .price-shield {
    font-size: 0.24rem;
    line-height: 0.32rem;
    color: #f03100;
  }
}
.sku-prce-tag {
  margin-bottom: 3px;
}
.open-ssu-btn {
  position: absolute;
  right: 0;
  bottom: -3px;

  background-color: #fff;
}
.operate-wrapper-promote {
  position: absolute;
  right: 0;
  bottom: -3px;

  width: 76px;
  height: 32px;
  font-size: 0;
  display: block;
}
</style>
